module.exports = __webpack_public_path__ + "static/media/Screenshot_app_5.672a68a6.png";